import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const phrases = [
  'Plan your trips with ease and make your dream vacation a reality.',
  'Find hidden gems off the beaten path.',
  'Tailor‑made itineraries built just for you.',
  'Travel smarter, not harder.'
];

const HeroSection = () => {
  const navigate = useNavigate();
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex]     = useState(0);
  const [isDeleting, setIsDeleting]   = useState(false);
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    const currentPhrase = phrases[phraseIndex];
    if (!isDeleting && charIndex === currentPhrase.length) {
      const holdTimer = setTimeout(() => setIsDeleting(true), 2000);
      return () => clearTimeout(holdTimer);
    }
    if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setPhraseIndex(prev => (prev + 1) % phrases.length);
    }
    const nextIndex = isDeleting ? charIndex - 1 : charIndex + 1;
    const typingDelay = isDeleting ? 45 : 110;
    const typingTimer = setTimeout(() => {
      setCharIndex(nextIndex);
      setDisplayText(currentPhrase.substring(0, nextIndex));
    }, typingDelay);
    return () => clearTimeout(typingTimer);
  }, [charIndex, isDeleting, phraseIndex]);

  const handleExploreClick = () => {
    const randomId = uuidv4();
    window.open(`${window.location.origin}/chat/${randomId}`, '_blank');
  };

  return (
    <div className="relative bg-cover bg-center h-screen flex flex-col">
      <img
        src={`${process.env.PUBLIC_URL}/assets/homepage.jpg`}
        alt="Hero background"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
      />


      <div className="flex-grow flex items-center justify-center text-center px-4 relative z-10">
        <div>
          <h1 className="text-white text-5xl font-bold mb-6 drop-shadow">
            Discover Your Next Adventure
          </h1>
          <p className="text-white text-xl mb-10 h-12">
            {displayText}
            <span className="border-r-2 border-white ml-1 animate-pulse" />
          </p>
          <button
            onClick={handleExploreClick}
            className="bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition duration-300 shadow-lg"
          >
            Start Exploring
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
